(() => {
  if (window.rrBrandDirectoryLoaded) return;
  window.rrBrandDirectoryLoaded = true;
  const initialized = new WeakSet();
  const normalize = value => value.normalize('NFKD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase().trim();
  const initialize = section => {
    if (initialized.has(section)) return;
    const input = section.querySelector('[data-brand-query]');
    const clear = section.querySelector('[data-brand-clear]');
    const count = section.querySelector('[data-brand-count]');
    const empty = section.querySelector('[data-brand-empty]');
    const entries = [...section.querySelectorAll('[data-brand-entry]')].map(element => ({ element, name: normalize(element.dataset.brandName) }));
    const groups = [...section.querySelectorAll('[data-brand-group]')];
    const letters = [...section.querySelectorAll('[data-brand-letter]')];
    if (!input || !clear || !count || !empty) return;
    initialized.add(section);
    const filter = () => {
      const query = normalize(input.value);
      let matches = 0;
      entries.forEach(({ element, name }) => {
        element.hidden = !name.includes(query);
        if (!element.hidden) matches += 1;
      });
      groups.forEach(group => { group.hidden = ![...group.querySelectorAll('[data-brand-entry]')].some(entry => !entry.hidden); });
      letters.forEach(link => {
        const available = groups.some(group => group.dataset.brandGroup === link.dataset.brandLetter && !group.hidden);
        link.setAttribute('aria-disabled', String(!available));
        link.tabIndex = available ? 0 : -1;
      });
      count.textContent = section.dataset.countTemplate.replace('__count__', String(matches));
      empty.hidden = matches > 0;
      clear.hidden = input.value.length === 0;
    };
    const reset = () => { input.value = ''; filter(); input.focus(); };
    input.addEventListener('input', filter);
    input.addEventListener('keydown', event => { if (event.key === 'Escape' && input.value) { event.preventDefault(); reset(); } });
    clear.addEventListener('click', reset);
    section.querySelector('[data-brand-reset]')?.addEventListener('click', reset);
    letters.forEach(link => link.addEventListener('click', event => { if (link.getAttribute('aria-disabled') === 'true') event.preventDefault(); }));
    section.querySelector('[data-brand-search]').hidden = false;
    filter();
  };
  const initializeWithin = scope => {
    if (scope.matches?.('[data-brand-directory]')) initialize(scope);
    scope.querySelectorAll('[data-brand-directory]').forEach(initialize);
  };
  initializeWithin(document);
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
})();
